import { useMutation } from "react-query";

import axios from "../../../../utils/authAxios";

const apiUrl =
  process.env.REACT_APP_API_BASEURL +
  "/BusinessLicensePermitDashboard/DownloadExcel";

export interface DownloadBLPDashboardExcelRequest {
  officeIds?: number[];
  officeRiskTop?: number;
}

const normalizeOfficeIds = (officeIds: number[] = []): number[] => {
  return Array.from(
    new Set(
      officeIds
        .map(Number)
        .filter((officeId) => Number.isInteger(officeId) && officeId > 0)
    )
  ).slice(0, 15);
};

const downloadBLPDashboardExcel = async (
  request: DownloadBLPDashboardExcelRequest = {}
): Promise<void> => {
  const officeIds = normalizeOfficeIds(request.officeIds);

  const requestedTop = Number(request.officeRiskTop);

  let officeRiskTop = 10;

  if (officeIds.length > 0) {
    officeRiskTop = officeIds.length;
  } else if (Number.isInteger(requestedTop) && requestedTop > 0) {
    officeRiskTop = Math.min(requestedTop, 15);
  }

  const params = new URLSearchParams();

  officeIds.forEach((officeId) => {
    params.append("OfficeIds", officeId.toString());
  });

  params.append("OfficeRiskTop", officeRiskTop.toString());

  const response = await axios.get<Blob>(apiUrl, {
    responseType: "blob",
    params,
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = globalThis.URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = url;

  link.setAttribute(
    "download",
    `BLPDashboard_${new Date().toISOString().slice(0, 10)}.xlsx`
  );

  document.body.appendChild(link);

  link.click();

  link.remove();

  globalThis.URL.revokeObjectURL(url);
};

export const useDownloadBLPDashboardExcel = () => {
  return useMutation<
    void,
    unknown,
    DownloadBLPDashboardExcelRequest | undefined
  >((request) => downloadBLPDashboardExcel(request ?? {}));
};
